"use client"

/**
 * Root Error Boundary
 *
 * This error boundary catches errors in the root layout, including errors
 * that prevent React from rendering. This is a last-resort error handler.
 *
 * Note: This file must include its own <html> and <body> tags because it
 * replaces the root layout when an error occurs.
 *
 * @see https://nextjs.org/docs/app/building-your-application/routing/error-handling#handling-errors-in-root-layouts
 */
export default function GlobalError({ error, reset }: { error: Error & { digest?: string }; reset: () => void }) {
  return (
    <html lang="en">
      <body>
        <div className="flex min-h-screen flex-col items-center justify-center bg-white px-4 dark:bg-gray-900">
          <div className="max-w-md text-center">
            <h1 className="mb-4 text-4xl font-bold text-gray-900 dark:text-white">Something went wrong</h1>
            <p className="mb-8 text-gray-600 dark:text-gray-400">
              We encountered an unexpected error. Please refresh the page or try again later.
            </p>
            {error.digest && (
              <p className="mb-4 font-mono text-sm text-gray-500 dark:text-gray-500">Error ID: {error.digest}</p>
            )}
            <button
              onClick={reset}
              className="rounded-lg bg-blue-600 px-6 py-3 text-white transition-colors hover:bg-blue-700 dark:bg-blue-500 dark:hover:bg-blue-600"
            >
              Try Again
            </button>
          </div>
        </div>
      </body>
    </html>
  )
}
